<card name="Ссылки">
  <div card content>
    <div class="row">
      <div class="col-30">
        <div class="form-group">
          <h6>Обычные</h6>
          <div>
            <a href="#">URL Адрес</a>
          </div>
        </div>
      </div>

      <div class="col-30">
        <div class="form-group">
          <h6>Кнопочные</h6>
          <div>
            <button class="btn btn-link">URL Адрес</button><br>
            <button class="btn btn-link" disabled>URL Адрес (disabled)</button>
          </div>
        </div>
      </div>

      <div class="col-30">
        <div class="form-group">
          <h6>Псевдо</h6>
          <div>
            <span class="pseudo-link">URL Адрес</span><br>
            <button class="pseudo-link">URL Адрес (button)</button><br>
            <button class="pseudo-link" disabled>URL Адрес (disabled)</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</card>
